import React from 'react'
import ContentLoader from 'react-content-loader'

const DoorDashFavorite = props => (
    <ContentLoader
        animate={true}
        speed={2}
        viewBox="0 0 450 500"
        backgroundColor="#F1F3F6"
        foregroundColor="#9A9B9D"
        {...props}
    >
        <circle cx="16" cy="32" r="15" />
        <rect x="40" y="18" rx="2" ry="2" width="140" height="10" />
        <rect x="41" y="36" rx="2" ry="2" width="140" height="10" />
        <rect x="0" y="60" rx="10" ry="10" width="450" height="400" />
    </ContentLoader>
)

DoorDashFavorite.metadata = {
    name: 'Nic Bovee', // My name
    github: 'ghettifish', // Github username
    description: 'A simple favorite from the DoorDash local favorites.', // Little tagline
    filename: 'DoorDashItem', // filename of your loader
}

export default DoorDashFavorite